module.exports = __webpack_public_path__ + "static/media/golf-club.67f982b0.svg";